/**
 * Client-side sort for Deals blog feed (filters use server-side tagged URLs).
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-crc-blog-filters]');
    var grid = document.querySelector('[data-crc-blog-grid]');
    var sort = root && root.querySelector('[data-crc-sort]');
    if (!grid || !sort) return;

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-crc-article-card]'));
    }

    function applySort() {
      var mode = sort.value;
      var sorted = cards().slice().sort(function (a, b) {
        if (mode === 'title') {
          return (a.getAttribute('data-crc-title') || '').localeCompare(b.getAttribute('data-crc-title') || '');
        }
        return (b.getAttribute('data-crc-date') || '').localeCompare(a.getAttribute('data-crc-date') || '');
      });
      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    sort.addEventListener('change', applySort);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
